import React from 'react';
import styles from './Management.module.css';


const Management = () => {
    // Data extracted from the new programs table image
    const managementPrograms = [
        { program: 'Bachelor of Business Administration (B.B.A.)', duration: '3 Years', eligibility: '10+2 or equivalent in any discipline with ≥45% (40% for SC/ST)', affiliation: 'MJPRU, Guru Jambheshwar Univ.' },
        { program: 'Bachelor of Computer Applications (B.C.A.)', duration: '3 Years', eligibility: '10+2 or equivalent in any discipline with ≥45% (40% for SC/ST)', affiliation: 'MJPRU, Guru Jambheshwar Univ.' },
        { program: 'Bachelor of Commerce (Hons.) [B. Com (H)]', duration: '3 Years', eligibility: '10+2 or equivalent in any discipline with ≥45% (40% for SC/ST)', affiliation: 'MJPRU, Guru Jambheshwar Univ.' },
        { program: 'Bachelor of Science (B.Sc.) Home Science', duration: '3 Years', eligibility: '10+2 or equivalent in any discipline with eligibility as per university norms', affiliation: 'MJPRU, Guru Jambheshwar Univ.' }
    ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>About Apex College of Management and Computer Applications</h1>
                <p>Founded with a vision to nurture future leaders in business and technology, Apex College of Management and Computer Applications stands out as a premier institution offering industry-driven programs in management, computer applications, commerce, and home science.</p>
                <p>The college is affiliated with both M.J.P. Rohilkhand University (MJPRU), Bareilly, and Guru Jambheshwar University, enhancing the credibility and recognition of its degrees.</p>
            </header>

            <section className={styles.principalMessage}>
                <div className={styles.principalImageContainer}>
                    <img src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1755453971/apex/b8477c7b-f9af-4689-8410-8cd9f244a2c8.png" alt="Dr. Gurpreet Singh, Principal" className={styles.principalImage} />
                </div>
                <div className={styles.principalText}>
                    <h2>Message from the Principal’s Desk</h2>
                    <p>Management education has taken a key and premier role among professional studies in this millennium. In our pursuit of excellence, we focus on imparting skills that prepare students to manage businesses and become leaders at par with the very best.</p>
                    <p>Apex College is dedicated to developing managers and business leaders who are committed and content in their fields. Through group discussions, seminars, and personality development workshops, we aim to shape the overall personality of each student.</p>
                    <h4>Dr. Gurpreet Singh</h4>
                    <p>Principal, ACMCA</p>
                </div>
            </section>

            <section className={styles.programsOffered}>
                <h2>Programs Offered</h2>
                <div className={styles.tableContainer}>
                    <table className={styles.programsTable}>
                        <thead>
                            <tr>
                                <th>Program</th>
                                <th>Duration</th>
                                <th>Eligibility</th>
                                <th>Affiliation(s)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {managementPrograms.map((program, index) => (
                                <tr key={index}>
                                    <td data-label="Program">{program.program}</td>
                                    <td data-label="Duration">{program.duration}</td>
                                    <td data-label="Eligibility">{program.eligibility}</td>
                                    <td data-label="Affiliation(s)">{program.affiliation}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles.uniqueFeatures}>
                <h2>Unique Features</h2>
                <ul>
                    <li><strong>Industry-Aligned Curriculum:</strong> Regular updates to incorporate the latest industry trends.</li>
                    <li><strong>Distinguished Faculty:</strong> Experienced educators and industry professionals guiding student growth.</li>
                    <li><strong>Modern Infrastructure:</strong> Smart classrooms and advanced laboratories foster hands-on learning.</li>
                    <li><strong>Corporate Exposure:</strong> Live projects, internships, and strong organizational collaborations.</li>
                    <li><strong>Skill Development:</strong> Focused workshops, seminars, and networking events for comprehensive growth.</li>
                    <li><strong>Strong Alumni Network:</strong> Alumni in renowned organizations offer mentorship and career support.</li>
                </ul>
            </section>

            <footer className={styles.footer}>
                <h3>Contact Information</h3>
                <p><strong>General Inquiries:</strong> +91-7351408009</p>
                <p><strong>Email:</strong> admissions@apex.in</p>
                <p className={styles.note}>Note: All program information is regularly updated. Prospective students are encouraged to confirm current offerings and admission policies prior to applying.</p>
            </footer>
        </div>
    );
};

export default Management;